'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _numbro = require('numbro');

var _numbro2 = _interopRequireDefault(_numbro);

var _icon = require('constructicon/icon');

var _icon2 = _interopRequireDefault(_icon);

var _loading = require('constructicon/loading');

var _loading2 = _interopRequireDefault(_loading);

var _metric = require('constructicon/metric');

var _metric2 = _interopRequireDefault(_metric);

var _donationTotals = require('../../api/donation-totals');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TotalFundsRaised = function (_Component) {
  _inherits(TotalFundsRaised, _Component);

  function TotalFundsRaised() {
    _classCallCheck(this, TotalFundsRaised);

    var _this = _possibleConstructorReturn(this, (TotalFundsRaised.__proto__ || Object.getPrototypeOf(TotalFundsRaised)).call(this));

    _this.fetchData = _this.fetchData.bind(_this);
    _this.state = { status: 'fetching' };
    return _this;
  }

  _createClass(TotalFundsRaised, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var refreshInterval = this.props.refreshInterval;

      this.fetchData();
      this.interval = refreshInterval && setInterval(this.fetchData, refreshInterval);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: 'fetchData',
    value: function fetchData() {
      var _this2 = this;

      var _props = this.props,
          campaign = _props.campaign,
          charity = _props.charity,
          event = _props.event,
          excludeOffline = _props.excludeOffline,
          country = _props.country,
          group = _props.group,
          startDate = _props.startDate,
          endDate = _props.endDate;


      (0, _donationTotals.fetchDonationTotals)({
        campaign: campaign,
        charity: charity,
        event: event,
        country: country,
        group: group,
        startDate: startDate,
        endDate: endDate
      }).then(function (data) {
        _this2.setState({
          status: 'fetched',
          data: (0, _donationTotals.deserializeDonationTotals)(data, excludeOffline)
        });
      }).catch(function (error) {
        _this2.setState({
          status: 'failed'
        });
        return Promise.reject(error);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          icon = _props2.icon,
          label = _props2.label,
          metric = _props2.metric;


      return _react2.default.createElement(_metric2.default, _extends({
        icon: icon,
        label: label,
        amount: this.renderAmount()
      }, metric));
    }
  }, {
    key: 'renderAmount',
    value: function renderAmount() {
      var _state = this.state,
          status = _state.status,
          _state$data = _state.data,
          data = _state$data === undefined ? {} : _state$data;
      var _props3 = this.props,
          currency = _props3.currency,
          format = _props3.format,
          offset = _props3.offset,
          multiplier = _props3.multiplier;

      var formatMethod = currency ? 'formatCurrency' : 'format';

      switch (status) {
        case 'fetching':
          return _react2.default.createElement(_loading2.default, null);
        case 'failed':
          return _react2.default.createElement(_icon2.default, { name: 'warning' });
        default:
          return (0, _numbro2.default)((offset + data.raised) * multiplier)[formatMethod](format);
      }
    }
  }]);

  return TotalFundsRaised;
}(_react.Component);

TotalFundsRaised.propTypes = {
  /**
   * The campaign uid to fetch totals for
   */
  campaign: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.array]),

  /**
   * The event uid to fetch totals for (JG only)
   */
  event: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.array]),

  /**
   * The charity uid to fetch totals for
   */
  activity: _propTypes2.default.oneOf([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.array]),

  /**
   * Country code for API (JG only)
   */
  country: _propTypes2.default.oneOf(['au', 'ca', 'gb', 'hk', 'ie', 'nz', 'sg', 'uk', 'us', 'za']),

  /**
   * Format as currency?
   */
  currency: _propTypes2.default.bool,

  /**
   * Exclude offline donations?
   */
  excludeOffline: _propTypes2.default.bool,

  /**
   * The group value(s) to filter by
   */
  group: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),

  /**
   * Start date filter (ISO Format)
   */
  startDate: _propTypes2.default.string,

  /**
   * End date filter (ISO Format)
   */
  endDate: _propTypes2.default.string,

  /**
   * Offset
   */
  offset: _propTypes2.default.number,

  /**
   * The amount to multiply the total by for custom conversions
   */
  multiplier: _propTypes2.default.number,

  /**
   * The label of the metric
   */
  label: _propTypes2.default.string,

  /**
   * The format of the number
   */
  format: _propTypes2.default.string,

  /**
   * The icon to use
   * - String representing a constructicon icon e.g. heart
   * - Array of custom paths
   * - An element to use instead e.g. <i className='fa fa-heart' />
   */
  icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.element]),

  /**
   * Props to be passed to the Constructicon Metric component
   */
  metric: _propTypes2.default.object,

  /**
   * Interval (in milliseconds) to refresh data from API
   */
  refreshInterval: _propTypes2.default.number
};

TotalFundsRaised.defaultProps = {
  currency: true,
  excludeOffline: false,
  format: '0,0',
  label: 'Funds Raised',
  multiplier: 1,
  offset: 0
};

exports.default = TotalFundsRaised;


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/components/total-funds-raised/index.js
// module id = 1448
// module chunks = 0